import styled from 'styled-components';

import ButtonDescriptionText from './ButtonDescriptionText';
import ButtonHeaderText from './ButtonHeaderText';

const SettingsPage = styled('div')``;

type PageProps = typeof SettingsPage & {
  ButtonDescriptionText: typeof ButtonDescriptionText;
  ButtonHeaderText: typeof ButtonHeaderText;
};

const Page = SettingsPage as PageProps;

Page.ButtonDescriptionText = ButtonDescriptionText;
Page.ButtonHeaderText = ButtonHeaderText;

export default Page;
